import React, { useEffect, useState } from "react";
import { FaCut } from "react-icons/fa";
import { FiLogIn } from "react-icons/fi";
import axios from "axios";
import Navbar from "../Navbar/Navbar";
import Ticket from "../Ticket/Ticket";
import "./Home.css";

export default function Home() {
  const [appointmentsFetched, setAppointmentsFetched] = useState(false); // Dodajemo flag za praćenje
  const [error, setError] = useState("");

  // Podaci za prikaz ticketa
  const [barbers, setBarbers] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [services, setServices] = useState([]);

  // State za modal rezervacijske forme
  const [showReservationForm, setShowReservationForm] = useState(false);

  // State za rezervacijski form inpute
  const [resName, setResName] = useState("");
  const [resLastName, setResLastName] = useState("");
  const [selectedBarber, setSelectedBarber] = useState("");
  const [barberServices, setBarberServices] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState("");

  // Podaci specifični za odabranog frizera (rezervacija)
  const [workingShifts, setWorkingShifts] = useState([]);
  const [barberSettings, setBarberSettings] = useState(null);
  const [barberVacations, setBarberVacations] = useState([]);
  const [currentAppointments, setCurrentAppointments] = useState([]);

  const today = new Date().toISOString().split("T")[0];

  // Dohvati globalne podatke (barbers, appointments i servise)
  useEffect(() => {
    axios
      .get("/api/barbers")
      .then((res) => setBarbers(res.data))
      .catch((err) => console.log("Error fetching barbers:", err));

    axios
      .get("/api/current-appointments")
      .then((res) => setAppointments(res.data))
      .catch((err) => console.log("Error fetching appointments:", err));

    axios
      .get("/api/services")
      .then((res) => setServices(res.data))
      .catch((err) => console.log("Error fetching services:", err));
  }, []);

  useEffect(() => {
    // Resetiranje svih podataka kad promijeniš barbera
    setSelectedService("");
    setSelectedDate("");
    setAvailableTimeSlots([]);
    setSelectedTimeSlot("");
    setBarberServices([]); // Očisti usluge
    setWorkingShifts([]); // Očisti radno vrijeme
    setBarberSettings([]); // Očisti postavke
    setBarberVacations([]); // Očisti odmor
    setCurrentAppointments([]); // Očisti postojeće termine
    setAppointmentsFetched(false); // Resetiraj status za učitane termine
  }, [selectedBarber]); // Ovisno o selectedBarber, resetiraj sve

  // Kada se odabere frizer u formi, dohvatiti njegove podatke
  useEffect(() => {
    if (!selectedBarber) return;
    if (appointmentsFetched) return;
    axios
      .get(`/api/service-by-barber/${selectedBarber}`)
      .then((res) => setBarberServices(res.data))
      .catch((err) => console.log("Error fetching barber services:", err));

    axios
      .get(`/api/work-shift-by-barber/${selectedBarber}`)
      .then((res) => setWorkingShifts(res.data))
      .catch((err) => console.log("Error fetching working shifts:", err));

    axios
      .get(`/api/barber-setting-by-barber/${selectedBarber}`)
      .then((res) => setBarberSettings(res.data))
      .catch((err) => console.log("Error fetching barber settings:", err));

    axios
      .get(`/api/barber-vacation-by-barber/${selectedBarber}`)
      .then((res) => setBarberVacations(res.data))
      .catch((err) => console.log("Error fetching barber vacations:", err));

    axios
      .get(`/api/all-appointments-by-barber/${selectedBarber}`)
      .then((res) => {
        setCurrentAppointments(res.data);
        setAppointmentsFetched(true);
      })
      .catch((err) => {
        console.log("Error fetching current appointments for barber:", err);
        setAppointmentsFetched(true);
      });
  }, [selectedBarber, barberSettings, appointmentsFetched]);

  useEffect(() => {
    // Provjera da su svi podaci dostupni
    if (
      !selectedDate ||
      workingShifts.length === 0 ||
      !Array.isArray(barberSettings) ||
      barberSettings.length === 0
    ) {
      setAvailableTimeSlots([]);
      return;
    }

    const settings = barberSettings[0];

    const today = new Date();
    const selDate = new Date(selectedDate);

    // Razlika u danima između danas i selektiranog datuma
    const diffDays = Math.ceil(
      (selDate.setHours(0, 0, 0, 0) - today.setHours(0, 0, 0, 0)) /
        (1000 * 60 * 60 * 24)
    );

    // Ako je izvan dozvoljenog roka za rezervaciju
    if (diffDays > settings.max_days_in_advance || diffDays < 0) {
      setAvailableTimeSlots([]);
      alert("1.if");
      return;
    }

    // Provjera odmora
    const isVacation = barberVacations.some((vac) => {
      const start = new Date(vac.start_date);
      const end = new Date(vac.end_date);
      start.setHours(0, 0, 0);
      return selDate >= start && selDate <= end;
    });
    if (isVacation) {
      //alert("2 if- odmor");
      setError("There are no appointments available");
      setAvailableTimeSlots([]);
      return;
    }

    // Nađi working shift za taj dan
    const shiftForDay = workingShifts.find((ws) => {
      const shiftStartDate = new Date(ws.start_date); // Koristimo start_date za početak
      const shiftEndDate = new Date(ws.end_date); // Koristimo end_date za kraj
      const selected = new Date(selectedDate); // Odabrani datum

      // Postavljamo vrijeme na 00:00 za usporedbu samo datuma
      shiftStartDate.setHours(0, 0, 0, 0);
      shiftEndDate.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);

      // Provjeravamo je li selectedDate unutar raspona od start_date do end_date
      return selected >= shiftStartDate && selected <= shiftEndDate;
    });

    if (!shiftForDay) {
      setAvailableTimeSlots([]);
      setError("There are no appointments available");
      return;
    }

    const generateTimeSlots = (start, end, maxAppointmentsPerDay) => {
      const slots = [];

      // Izračunaj ukupnu duljinu vremena u minutama
      const totalMinutes = (end - start) / (1000 * 60); // u minutama

      // Izračunaj interval u minutama na temelju maxAppointmentsPerDay
      const interval = totalMinutes / maxAppointmentsPerDay; // interval u minutama

      let current = new Date(start);

      // Generiraj sve termine prema izračunatom intervalu
      while (current < end) {
        slots.push(new Date(current));
        current = new Date(current.getTime() + interval * 60000); // povećaj za interval u minutama
      }

      return slots;
    };

    // U funkciji useEffect ili u odgovarajućem kontekstu:
    const [startHour, startMinute] = shiftForDay.start_time
      .split(":")
      .map(Number);
    const [endHour, endMinute] = shiftForDay.end_time.split(":").map(Number);

    // Start i end time za dan (pretpostavljamo da je selectedDate u formatu "YYYY-MM-DD")
    const startDateTime = new Date(selectedDate);
    startDateTime.setHours(startHour, startMinute, 0, 0); // 12:00

    const endDateTime = new Date(selectedDate);
    endDateTime.setHours(endHour, endMinute, 0, 0); // 20:00

    // Generiraj termine
    let slots = generateTimeSlots(
      startDateTime,
      endDateTime,
      barberSettings[0]?.max_appointments_per_day
    );

    // Formatiraj vrijeme
    const formatTime = (date) => {
      const hh = date.getHours().toString().padStart(2, "0");
      const mm = date.getMinutes().toString().padStart(2, "0");
      return `${hh}:${mm}`;
    };

    // Filtriraj zauzete termine
    const bookedSlots = currentAppointments
      .filter((app) => {
        const appointmentDate = new Date(app.date); // Razvodi datum iz currentAppointments
        const selectedDateObj = new Date(selectedDate); // Razvodi selektirani datum

        // Provjera je li datum isti
        return (
          appointmentDate.toISOString().slice(0, 10) ===
          selectedDateObj.toISOString().slice(0, 10)
        );
      })
      .map((app) => {
        // alert(JSON.stringify(app));
        // Formatiraj time_slot da bude u obliku hh:mm (bez sekundi)
        return app.time_slot.split(":").slice(0, 2).join(":");
      });

    slots = slots.filter((slot) => !bookedSlots.includes(formatTime(slot)));

    // Provjera max broja rezervacija za taj dan
    const appointmentsForDay = currentAppointments.filter(
      (app) => app.date === selectedDate
    );
    if (
      appointmentsForDay.length >= barberSettings[0]?.max_appointments_per_day
    ) {
      slots = []; // Ako je broj termina premašio max, resetiraj slotove
    }

    // Postavi slobodne termine
    setAvailableTimeSlots(slots.map(formatTime));
  }, [
    selectedDate,
    workingShifts,
    barberSettings,
    barberVacations,
    currentAppointments,
  ]);

  // Handler za submit rezervacijske forme
  const handleReservationSubmit = (e) => {
    e.preventDefault();
    if (
      !resName ||
      !resLastName ||
      !selectedBarber ||
      !selectedService ||
      !selectedDate ||
      !selectedTimeSlot
    ) {
      alert("Please fill in all fields.");
      return;
    }
    //popravi
    const payload = {
      barberId: selectedBarber,
      date: selectedDate,
      lastName: resLastName,
      name: resName,
      serviceId: selectedService,
      timeSlot: selectedTimeSlot,
    };

    axios
      .post("/api/appointment", payload)
      .then((res) => {
        alert("Reservation created successfully!");
        setResName("");
        setResLastName("");
        setSelectedBarber("");
        setSelectedService("");
        setSelectedDate("");
        setSelectedTimeSlot("");
        setAvailableTimeSlots([]);
        setShowReservationForm(false);
        axios
          .get(`/api/all-appointments-by-barber/${selectedBarber}`)
          .then((res) => {
            setCurrentAppointments(res.data);
          })
          .catch((err) => {
            console.error("Error fetching all appointments for barber:", err);
          });
        axios
          .get(`/api/appointments-by-barber/${selectedBarber}`)
          .then((res) => {
            setAppointments(res.data);
          })
          .catch((err) => {
            console.error(
              "Error fetching current appointments for barber:",
              err
            );
          });
      })
      .catch((err) => {
        console.error("Error creating reservation:", err);
        alert("Failed to create reservation.");
      });
  };

  return (
    <div className="home">
      <Navbar
        leftIcon={FaCut}
        leftLink="/"
        rightIcon={FiLogIn}
        rightLink="/login"
      />

      <div className="barber-container">
        {appointments.length > 0 ? (
          barbers
            .filter((barber) =>
              appointments.some(
                (appointment) => appointment.barber_id === barber.id
              )
            )
            .map((barber) => {
              const barberAppointments = appointments.filter(
                (appointment) => appointment.barber_id === barber.id
              );

              return (
                <div key={barber.id} className="barber-section">
                  <h2 className="barber-name">
                    {barber.name} {barber.last_name}
                  </h2>
                  <div className="ticket-container">
                    {barberAppointments
                      .slice() // kopira array da ne mijenja original
                      .sort((a, b) => a.time_slot.localeCompare(b.time_slot)) // sortira po vremenu
                      .map((appointment) => {
                        const service = services.find(
                          (s) => s.id === appointment.service_id
                        );
                        return (
                          <Ticket
                            key={appointment.id}
                            time={appointment.time_slot.slice(0, 5)} // "12:00:00" → "12:00"
                            name={`${appointment.name} ${appointment.last_name}`}
                            service={
                              service ? service.name : "Nepoznata usluga"
                            }
                          />
                        );
                      })}
                  </div>
                </div>
              );
            })
        ) : (
          <p className="no-appointments">Nema zakazanih termina.</p>
        )}

        {!showReservationForm && (
          <button
            onClick={() => setShowReservationForm(true)}
            className="new-reservation-btn"
          >
            New Reservation
          </button>
        )}
      </div>

      {showReservationForm && (
        <div className="reservation-modal">
          <div className="reservation-form-container">
            <h3>Create New Reservation</h3>
            <form onSubmit={handleReservationSubmit}>
              <label>
                First Name:
                <input
                  type="text"
                  value={resName}
                  onChange={(e) => setResName(e.target.value)}
                  required
                />
              </label>
              <label>
                Last Name:
                <input
                  type="text"
                  value={resLastName}
                  onChange={(e) => setResLastName(e.target.value)}
                  required
                />
              </label>
              <label>
                Select Barber:
                <select
                  value={selectedBarber}
                  onChange={(e) => {
                    setSelectedBarber(e.target.value);
                    // Reset dependent dropdowns/fields
                    setSelectedService("");
                    setSelectedDate("");
                    setAvailableTimeSlots([]);
                    setSelectedTimeSlot("");
                  }}
                  required
                >
                  <option value="">-- Select Barber --</option>
                  {barbers.map((barber) => (
                    <option key={barber.id} value={barber.id}>
                      {barber.name} {barber.lastName}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Select Service:
                <select
                  value={selectedService}
                  onChange={(e) => setSelectedService(e.target.value)}
                  required
                >
                  <option value="">-- Select Service --</option>
                  {barberServices.map((srv) => (
                    <option key={srv.id} value={srv.id}>
                      {srv.name}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Select Date:
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  min={today}
                  required
                />
              </label>
              {error && <p className="error-message">{error}</p>}
              <label>
                Select Time Slot:
                <select
                  value={selectedTimeSlot}
                  onChange={(e) => setSelectedTimeSlot(e.target.value)}
                  required
                >
                  <option value="">-- Select Time Slot --</option>
                  {availableTimeSlots.map((slot, idx) => (
                    <option key={idx} value={slot}>
                      {slot}
                    </option>
                  ))}
                </select>
              </label>
              <div className="form-buttons">
                <button type="submit">Reserve</button>
                <button
                  type="button"
                  onClick={() => {
                    setResName("");
                    setResLastName("");
                    setSelectedBarber("");
                    setSelectedService("");
                    setSelectedDate("");
                    setSelectedTimeSlot("");
                    setAvailableTimeSlots([]);
                    setShowReservationForm(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
